module.exports = __webpack_public_path__ + "img/redbg_behind@3x.98a38a81.png";